import { RadioGroup } from '@headlessui/react';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { IntervalType } from '../../../../types/IntervalType';
import { CustomIntervalPicker } from './CustomIntervalPicker';

const optionStyling = ({ checked }: { active: boolean; checked: boolean }) => `
    px-1.5 py-2 sm:px-4 focus:underline focus:outline-none
    ${checked ? 'text-bnd-green' : 'text-gray-400 hover:text-gray-800'}
`;

export const IntervalPicker: React.FC<{
    interval: IntervalType;
    onIntervalChange: (interval: IntervalType, custom?: { endDate: DateTime; startDate: DateTime }) => void;
}> = ({ interval, onIntervalChange }) => {
    const [isCustomPickerShown, setIsCustomPickerShown] = useState(false);
    return (
        <div className="relative self-stretch md:self-center">
            <div className="flex flex-row flex-wrap">
                <RadioGroup
                    value={interval}
                    onChange={(value) => {
                        onIntervalChange(value);
                    }}
                    className="flex flex-row items-center"
                >
                    <RadioGroup.Option value="1M" className={optionStyling} as="button">
                        1M
                    </RadioGroup.Option>
                    <RadioGroup.Option value="1Y" className={optionStyling} as="button">
                        1J
                    </RadioGroup.Option>
                    <RadioGroup.Option value="5Y" className={optionStyling} as="button">
                        5J
                    </RadioGroup.Option>
                    <RadioGroup.Option value="10Y" className={optionStyling} as="button">
                        10J
                    </RadioGroup.Option>
                    <RadioGroup.Option value="1M" className={optionStyling} as="button"></RadioGroup.Option>
                </RadioGroup>
                <div
                    className={`${optionStyling({
                        active: true,
                        checked: interval === 'Custom' ? true : false,
                    })} cursor-pointer`}
                    onClick={() => {
                        setIsCustomPickerShown(!isCustomPickerShown);
                    }}
                >
                    Aangepast
                </div>
            </div>
            <CustomIntervalPicker
                isCustomPickerShown={isCustomPickerShown}
                setIsCustomPickerShown={setIsCustomPickerShown}
                onIntervalChange={onIntervalChange}
            />
        </div>
    );
};
